module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cardx"
  }, [_c('div', {
    staticStyle: {
      "margin": "0.7em"
    }
  }, [(_vm.site_view == 1) ? _c('div', {
    staticStyle: {
      "margin-left": "0.4em"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [(_vm.menu_tab_inner_view['viewOrder']) ? _c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-left"
  })]) : _c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-left"
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), (!_vm.menu_tab_inner_view['viewOrder']) ? _c('div', [_c('h4', {
    staticStyle: {
      "float": "left",
      "font-weight": "800",
      "font-size": "28px"
    }
  }, [_vm._v("Orders")]), _vm._v(" "), (_vm.site_user_type == 2) ? _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', [_vm._m(2)]) : _c('div', {
    staticClass: "card"
  }, [(_vm.menu_tab_inner_view['editProduct']) ? _c('div') : (_vm.menu_tab_inner_view['viewOrder']) ? _c('div', [(_vm.site_view == 2) ? _c('div', {
    staticStyle: {
      "margin-left": "0.4em"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [(_vm.menu_tab_inner_view['viewOrder']) ? _c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-left"
  })]) : _c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-left"
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-offset-0 col-md-7 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('h1', [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-left"
  })]), _vm._v("  ")]), _vm._v("Order Invoice")])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-bottom": "4em"
    }
  }, [_c('div', [_c('div', {
    staticClass: "o-top",
    staticStyle: {
      "text-align": "center"
    }
  }, [(((_vm.user_type == 3) && (_vm.order.order_delivery_business && (_vm.order.order_delivery_business.business == _vm.sellpoint.business_id)))) ? _c('div', [_c('h3', {
    staticStyle: {
      "font-weight": "800"
    }
  }, [_vm._v(_vm._s(_vm.order.order_delivery_business.business_name))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "800"
    }
  }, [_vm._v("Order Delivery Invoice")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.order.order_date))])]) : _c('div', [_c('h3', {
    staticStyle: {
      "font-weight": "800"
    }
  }, [_vm._v(_vm._s(_vm.order.order_business))]), _vm._v(" "), _c('p', [_vm._v("09088777888")]), _vm._v(" "), (_vm.order.order_business_phone && (_vm.order.order_business_phone != '')) ? _c('p', [_vm._v(_vm._s(_vm.order.order_business_phone))]) : _vm._e(), _vm._v(" "), (_vm.order.order_business_address && (_vm.order.order_business_address != '')) ? _c('p', [_vm._v(_vm._s(_vm.order.order_business_address))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "800"
    }
  }, [_vm._v("Order Invoice")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.order.order_date))])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "text-align": "left",
      "margin-top": "5px",
      "padding-top": "5px",
      "border-top": "#777777 1px dashed",
      "border-bottom": "#777777 1px dashed"
    }
  }, [_c('table', {
    staticClass: "table ctable"
  }, [_c('tr', [_c('td', {
    staticClass: "title"
  }, [_vm._v("No:")]), _vm._v(" "), _c('td', {
    staticClass: "t-info"
  }, [_vm._v(_vm._s(_vm.order.order_no))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "title"
  }, [(((_vm.user_type == 3) && (_vm.order.order_delivery_business && (_vm.order.order_delivery_business.business == _vm.sellpoint.business_id)))) ? _c('span', [_vm._v("To:")]) : _c('span', [_vm._v("From:")])]), _vm._v(" "), _c('td', {
    staticClass: "t-info"
  }, [_vm._v(_vm._s(_vm.order.order_user_name))])]), _vm._v(" "), (_vm.order.order_user_phone != '') ? _c('tr', [_c('td', {
    staticClass: "title"
  }, [_vm._v("Phone:")]), _vm._v(" "), _c('td', {
    staticClass: "t-info"
  }, [_vm._v(_vm._s(_vm.order.order_user_phone))])]) : _vm._e(), _vm._v(" "), (_vm.order.order_user_email != '') ? _c('tr', [_c('td', {
    staticClass: "title"
  }, [_vm._v("Email:")]), _vm._v(" "), _c('td', {
    staticClass: "t-info"
  }, [_vm._v(_vm._s(_vm.order.order_user_email))])]) : _vm._e(), _vm._v(" "), (_vm.order.order_delivery_city && (_vm.order.order_delivery_city != '')) ? _c('tr', [_c('td', {
    staticClass: "title"
  }, [_vm._v("Delivery:")]), _vm._v(" "), _c('td', {
    staticClass: "t-info"
  }, [(((_vm.order.order_delivery_city != '') && (_vm.order.order_delivery_city_id != 0))) ? _c('span', [_vm._v(_vm._s(_vm.order.order_delivery_city) + ",")]) : _vm._e(), _vm._v(" "), (_vm.order.order_delivery_state && (_vm.order.order_delivery_state != '')) ? _c('span', [_vm._v(" " + _vm._s(_vm.order.order_delivery_state))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.order.order_user_delivery_address && (_vm.order.order_user_delivery_address != '')) ? _c('tr', [_c('td', {
    staticClass: "title"
  }, [_vm._v("Address:")]), _vm._v(" "), _c('td', {
    staticClass: "t-info"
  }, [_vm._v(_vm._s(_vm.order.order_user_delivery_address))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "text-align": "left",
      "margin-top": "5px",
      "padding": "10px 0 3px 0",
      "border-top": "#777777 1px dashed",
      "border-bottom": "#777777 1px dashed"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 mp0"
  }, [_c('div', {
    staticClass: "o-cta-list"
  }, [_c('p', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.set_in_view = 'setRateProductView'
        _vm.set_toggleSingleComponent('popBox')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-star"
  }), _vm._v(" Rate & Review\r\n                        "), _c('span', {
    staticStyle: {
      "float": "right",
      "color": "#777777",
      "font-size": "12px"
    }
  }, [(((_vm.site_user_type == 2) || (Object.keys(_vm.order.order_user_review).length > 0))) ? _c('span', {
    staticClass: "x-btn-2"
  }, [_vm._v("View >")]) : _c('span', {
    staticClass: "x-btn-2"
  }, [_vm._v("Rate >")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), ((_vm.user_type == 1) || (_vm.user_type == 2)) ? _c('p', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.set_in_view = 'setReceiptsView'
        _vm.set_toggleSingleComponent('popBox')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-upload"
  }), _vm._v(" Order Receipts\r\n                        "), _c('span', {
    staticStyle: {
      "float": "right",
      "color": "#777777",
      "font-size": "12px"
    }
  }, [(((_vm.site_user_type == 2) || (Object.keys(_vm.order_media).length > 0))) ? _c('span', {
    staticClass: "x-btn-2"
  }, [_vm._v("View >")]) : _c('span', {
    staticClass: "x-btn-2"
  }, [_vm._v("Upload >")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "clear": "both"
    }
  })])]) : _vm._e(), _vm._v(" "), ((_vm.user_type == 1) || (_vm.user_type == 2)) ? _c('p', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.set_in_view = 'setOrderUpdateStatus'
        _vm.set_toggleSingleComponent('popBox')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-pencil-alt"
  }), _vm._v(" Order Status\r\n                        "), _c('span', {
    staticStyle: {
      "float": "right",
      "color": "#777777",
      "font-size": "12px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.order.order_status))]), _vm._v(" "), (_vm.order.order_status_id != 21) ? _c('span', [_vm._v("   \r\n                            "), _c('span', {
    staticClass: "x-btn-2"
  }, [_vm._v("Update >")])]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticStyle: {
      "clear": "both"
    }
  })])]) : _vm._e(), _vm._v(" "), ((_vm.user_type == 3)) ? _c('p', [_c('i', {
    staticClass: "fas fa-pencil-alt"
  }), _vm._v(" Delivery Status"), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right",
      "color": "#777777",
      "font-size": "12px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [(_vm.order.order_status_id == 21) ? _c('span', [_vm._v(_vm._s(_vm.order.order_status))]) : _c('span', [_vm._v("Pending")])])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e(), _vm._v(" "), (((_vm.user_type != 3))) ? _c('div', [(_vm.order.order_delivery_business && (_vm.order.order_delivery_business.business_category == 37)) ? _c('p', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.set_in_view = 'setDeliveryPartnerDetails'
        _vm.set_toggleSingleComponent('popBox')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-shipping-fast"
  }), _vm._v(" Delivery Information\r\n                          "), _c('span', {
    staticClass: "x-btn-2",
    staticStyle: {
      "float": "right",
      "color": "#777777",
      "font-size": "12px"
    }
  }, [_vm._v("Check >")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "clear": "both"
    }
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.order.order_delivery_business && (_vm.order.order_delivery_business.business_category == 37)) ? _c('div', [((_vm.user_type == 3)) ? _c('p', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.set_in_view = 'setDeliveryReceiptsView'
        _vm.set_toggleSingleComponent('popBox')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-upload"
  }), _vm._v(" Delivery Receipts\r\n                          "), _c('span', {
    staticStyle: {
      "float": "right",
      "color": "#777777",
      "font-size": "12px"
    }
  }, [(((_vm.site_user_type == 2) || (Object.keys(_vm.order_media).length > 0))) ? _c('span', {
    staticClass: "x-btn-2"
  }, [_vm._v("View >")]) : _c('span', {
    staticClass: "x-btn-2"
  }, [_vm._v("Upload >")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "clear": "both"
    }
  })])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), (_vm.site_view == 1) ? _c('div', {
    staticClass: "card",
    staticStyle: {
      "text-align": "left",
      "margin-top": "5px",
      "padding-top": "15px",
      "border-top": "#777777 1px dashed",
      "border-bottom": "#777777 1px dashed"
    }
  }, [_c('table', {
    staticClass: "table itm-table"
  }, [_vm._m(3), _vm._v(" "), _vm._l((_vm.order.order_items), function(item, index) {
    return _c('tr', [_c('td', {
      staticClass: "t-qty"
    }, [_vm._v(_vm._s(item.order_item_quantity))]), _vm._v(" "), _c('td', {
      staticClass: "t-item"
    }, [_c('div', [_c('img', {
      staticStyle: {
        "width": "30px",
        "height": "30px",
        "border-radius": "8px"
      },
      attrs: {
        "src": _vm.img_product_url + item.product_item_group_image
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.product_name))])])]), _vm._v(" "), _c('td', {
      staticClass: "t-cost"
    }, [_c('span', {
      staticClass: "nra-fmt"
    }, [_vm._v("₦‎")]), _vm._v(_vm._s(_vm.formatCurrency_2(item.order_item_total)))])])
  })], 2)]) : _vm._e()])]), _vm._v(" "), (_vm.site_view == 2) ? _c('div', {
    staticClass: "col-md-5 mobi-off pop-box"
  }, [_c('div', {
    staticClass: "pop-box-inner"
  }, [_c('div', {
    staticClass: "pop-box-inner-main"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "text-align": "left",
      "margin-top": "5px",
      "padding-top": "15px",
      "border-top": "#777777 1px dashed",
      "border-bottom": "#777777 1px dashed"
    }
  }, [_c('h3', [_vm._v("Items Ordered")]), _c('hr'), _vm._v(" "), _c('table', {
    staticClass: "table itm-table"
  }, [_vm._m(4), _vm._v(" "), _vm._l((_vm.order.order_items), function(item, index) {
    return _c('tr', [_c('td', {
      staticClass: "t-qty"
    }, [_vm._v(_vm._s(item.order_item_quantity))]), _vm._v(" "), _c('td', {
      staticClass: "t-item"
    }, [_c('div', [_c('img', {
      staticStyle: {
        "width": "30px",
        "height": "30px",
        "border-radius": "8px"
      },
      attrs: {
        "src": _vm.img_product_url + item.product_item_group_image
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.product_name))])])]), _vm._v(" "), _c('td', {
      staticClass: "t-cost"
    }, [_vm._v(_vm._s(item.order_item_total))])])
  })], 2)])])])]) : _vm._e()]) : _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "col-xs-3 col-md-2 card-col-menu"
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuActive('card-menu-col', 0);
        _vm.orders = _vm.orders_store
      }
    }
  }, [_vm._m(5)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 col-md-2 card-col-menu"
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuActive('card-menu-col', 1);
        _vm.sortOrders(0, _vm.orders_store, 2, 'today');
      }
    }
  }, [_vm._m(6)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 col-md-2 card-col-menu"
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuActive('card-menu-col', 2);
        _vm.sortOrders(0, _vm.orders_store, 2, 'not-paid');
      }
    }
  }, [_vm._m(7)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 col-md-2 card-col-menu"
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuActive('card-menu-col', 3);
        _vm.sortOrders(0, _vm.orders_store, 2, 'delivered')
      }
    }
  }, [_vm._m(8)])]), _vm._v(" "), (_vm.site_view == 2) ? _c('div', [_c('div', {
    staticClass: "col-xs-3 col-md-2 card-col-menu"
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuActive('card-menu-col', 4);
        _vm.sortOrders(0, _vm.orders_store, 2, 'week');
      }
    }
  }, [_vm._m(9)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 col-md-2 card-col-menu"
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuActive('card-menu-col', 5);
        _vm.sortOrders(0, _vm.orders_store, 2, 'month');
      }
    }
  }, [_vm._m(10)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "800",
      "margin-left": "0.5em"
    }
  }, [_vm._v("Total (" + _vm._s(Object.keys(_vm.orders).length) + ")")]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin": "1em"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-bottom": "8em"
    }
  }, [((Object.keys(_vm.orders).length > 0)) ? _c('div', [(_vm.site_view == 1) ? _c('div', [_c('div', _vm._l((_vm.orders), function(order) {
    return _c('div', {
      staticClass: "card-box card-02",
      staticStyle: {
        "padding": "0em 1em",
        "border-bottom": "#eee solid",
        "margin-bottom": "0.02em"
      }
    }, [_c('a', {
      staticClass: "card-link",
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "href": '/' + order.order_business_username + '/reorder/' + order.order_no
      }
    }, [_c('i', {
      staticClass: "fa fa-refresh",
      staticStyle: {
        "padding-top": "5px",
        "color": "#ff0000",
        "font-weight": "600"
      }
    }), _vm._v(" Re-Order")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.setOrderData(order)
        }
      }
    }, [_c('div', {
      staticClass: "col-xs-4 mp0"
    }, [_c('div', {
      staticStyle: {
        "display": "inline",
        "padding-bottom": "1em"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "80px",
        "height": "75px",
        "border-radius": "8px"
      },
      attrs: {
        "src": _vm.img_product_url + order.order_items[0].product_item_group_image
      }
    }), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-8 mp0"
    }, [(_vm.user_type == 3) ? _c('h4', {
      staticStyle: {
        "font-weight": "800",
        "font-size": "16px"
      }
    }, [_vm._v("\r\n                        Delivery to " + _vm._s(order.order_delivery_city) + "\r\n                        "), (order.order_business_location && (order.order_business_location != '')) ? _c('span', [_vm._v("\r\n                          From " + _vm._s(order.order_business_location) + "\r\n                        ")]) : _vm._e()]) : _c('h4', {
      staticStyle: {
        "font-weight": "800"
      }
    }, [_vm._v(_vm._s(order.order_items[0].product_name) + "\r\n                        "), (Object.keys(order.order_items).length > 1) ? _c('span', [_vm._v(" x " + _vm._s(Object.keys(order.order_items).length) + " more items")]) : _vm._e()]), _vm._v(" "), _c('p', [_c('span', {
      staticClass: "nra-fmt"
    }, [_vm._v("₦‎")]), _vm._v(_vm._s(_vm.formatCurrency_2(order.order_total)))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "float": "right",
        "margin-top": "0em",
        "color": "#777777"
      }
    }, [_vm._v(_vm._s(order.order_time_ago) + " >")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, _vm._l((_vm.orders), function(order, index) {
    return _c('div', {
      staticClass: "card-box card-02",
      staticStyle: {
        "border-bottom": "#eee solid",
        "margin-bottom": "2em"
      }
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.setOrderData(order)
        }
      }
    }, [_c('div', {
      staticClass: "col-xs-3 mp0"
    }, [_c('p', {
      staticClass: "prd-name-2-lines",
      staticStyle: {
        "font-size": "12px",
        "padding-right": "1em"
      }
    }, [_c('b', [_vm._v(_vm._s(order.order_time_ago))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "inline",
        "padding-bottom": "1em"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "40px",
        "height": "40px",
        "border-radius": "8px"
      },
      attrs: {
        "src": _vm.img_product_url + order.order_items[0].product_item_group_image
      }
    }), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9 mp0"
    }, [_c('div', {
      staticClass: "col-xs-12 mp0 xl-row"
    }, [_vm._m(11, true), _vm._v(" "), _c('div', {
      staticClass: "col-xs-10 mp0"
    }, [_c('p', {
      staticClass: "txt-1-lines",
      staticStyle: {
        "margin-top": "3px"
      }
    }, [_vm._v(" " + _vm._s(order.order_user))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 mp0 xl-row"
    }, [_c('div', {
      staticClass: "col-xs-4 mp0"
    }, [_c('p', [_c('b', [_vm._v(_vm._s((order.order_items).length))]), _vm._v(" Item(s)")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 mp0"
    }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6 mp0"
    }, [_c('div', {
      staticStyle: {
        "display": "none"
      }
    }, [(order.order_status_id == 2) ? _c('span', {
      staticClass: "p-status",
      staticStyle: {
        "color": "#ffffff",
        "background-color": "#09c046"
      }
    }, [_vm._v(" " + _vm._s(order.order_status) + " ")]) : (order.order_status_id == 7) ? _c('span', {
      staticClass: "p-status",
      staticStyle: {
        "color": "#ffffff",
        "background-color": "#ff0000"
      }
    }, [_vm._v(_vm._s(order.order_status))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 mp0 xl-row"
    }, [_c('div', {
      staticClass: "col-xs-6 mp0"
    }, [_c('a', {
      staticClass: "card-link",
      attrs: {
        "href": '/' + order.order_business_username + '/reorder/' + order.order_no
      }
    }, [_c('i', {
      staticClass: "fa fa-refresh",
      staticStyle: {
        "color": "#ff0000",
        "font-weight": "600"
      }
    }), _vm._v(" Re-Order")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6 mp0"
    }, [_c('a', {
      staticClass: "card-link cta-v",
      staticStyle: {
        "color": "#ff0000",
        "font-size": "13px"
      },
      on: {
        "click": function($event) {
          _vm.setOrderData(order)
        }
      }
    }, [_vm._v("view order "), _c('i', {
      staticClass: "fas fa-angle-right"
    })])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.site_view == 2) ? _c('div', [_c('table', {
    staticClass: "table"
  }, [_vm._m(12), _vm._v(" "), _c('tbody', _vm._l((_vm.orders), function(order, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', [_c('p', [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('b', [_vm._v(_vm._s(order.order_no))])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('a', {
      staticClass: "card-link cta-s",
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('ordt-' + index)
        }
      }
    }, [_vm._v("see Items "), _c('i', {
      staticClass: "fas fa-angle-down"
    })])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-12 mp0",
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'ordt-' + index
      }
    }, _vm._l((order.order_items), function(item, index) {
      return (index < 4) ? _c('div', {
        key: item.order_item_no,
        staticStyle: {
          "margin-bottom": "0.5em"
        }
      }, [_c('div', {
        staticClass: "col-md-2 mp0"
      }, [_c('img', {
        staticStyle: {
          "width": "30px",
          "height": "30px",
          "border-radius": "8px"
        },
        attrs: {
          "src": _vm.img_product_url + item.product_item_group_image
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "col-md-10"
      }, [_c('p', [_vm._v(_vm._s(item.product_name))])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "clear": "both"
        }
      })]) : _vm._e()
    }))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.order_date_f))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.order_items.length))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.order_user_name))]), _vm._v(" "), _c('td', [(order.order_delivery_city != '') ? _c('span', [_vm._v(_vm._s(order.order_delivery_city))]) : _c('span', [_vm._v("Not Set")])]), _vm._v(" "), _c('td', [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(order.order_total)))]), _vm._v(" "), _c('td', [(order.order_status_id == 2) ? _c('p', {
      staticClass: "p-status",
      staticStyle: {
        "background-color": "#09c046"
      }
    }, [_vm._v(_vm._s(order.order_status))]) : (order.order_status_id == 7) ? _c('p', {
      staticClass: "p-status",
      staticStyle: {
        "background-color": "#ff0000"
      }
    }, [_vm._v(_vm._s(order.order_status))]) : (order.order_status_id == 21) ? _c('p', {
      staticClass: "p-status",
      staticStyle: {
        "background-color": "#f7df2b",
        "color": "#000000"
      }
    }, [_vm._v("Received")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.order_time_ago))]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "card-link",
      attrs: {
        "href": '/' + order.order_business_username + '/reorder/' + order.order_no
      }
    }, [_c('i', {
      staticClass: "fa fa-refresh",
      staticStyle: {
        "color": "#ff0000",
        "font-weight": "600"
      }
    }), _vm._v(" Re-Order")])]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "card-link cta-v",
      on: {
        "click": function($event) {
          _vm.setOrderData(order)
        }
      }
    }, [_vm._v("view order "), _c('i', {
      staticClass: "fas fa-angle-right"
    })])])])
  }))])]) : _vm._e()]) : _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "5em"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No Orders yet")])])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "popBox"
    }
  }, [_c('div', {
    staticClass: "pop-box"
  }, [_c('div', {
    staticClass: "pop-box-inner"
  }, [_c('div', {
    staticClass: "pop-box-inner-main"
  }, [_c('div', [(_vm.site_view == 2) ? _c('a', {
    staticStyle: {
      "color": "inherit",
      "display": "block"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('popBox')
      }
    }
  }, [_vm._m(13), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em",
      "font-size": "18px"
    }
  }, [_vm._v("X")])]) : _c('a', {
    staticStyle: {
      "color": "inherit",
      "display": "block"
    },
    on: {
      "click": function($event) {
        _vm.set_toggleSingleComponent('popBox')
      }
    }
  }, [_vm._m(14), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em",
      "font-size": "18px",
      "font-weight": "bolder"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.set_in_view == 'setRateProductView') ? _c('div', [(((_vm.user_type == 3) && (_vm.order.order_delivery_business && (_vm.order.order_delivery_business.business == _vm.sellpoint.business_id)))) ? _c('div', [(_vm.order.order_user_delivery_review && (Object.keys(_vm.order.order_user_delivery_review).length > 0)) ? _c('div', {
    staticClass: "card"
  }, [_c('hr', {
    staticStyle: {
      "margin": "8px"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.order.order_user_delivery_review[0].product_review))]), _vm._v(" "), _c('p', {
    staticClass: "rate",
    staticStyle: {
      "line-height": "0.7",
      "margin-top": "-0.2em"
    }
  }, _vm._l((Math.round(_vm.order.order_user_delivery_review[0].product_rate)), function(rate) {
    return _c('i', {
      staticClass: "fas fa-star",
      staticStyle: {
        "padding-right": "3px"
      }
    })
  })), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.order.order_user_delivery_review[0].product_reviewed_by) + "'s Review")])]) : _c('div', {
    staticClass: "card"
  }, [(_vm.site_user_type == 2) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No reviews yet")]) : _vm._e()])]) : _c('div', [(_vm.order.order_user_review && (Object.keys(_vm.order.order_user_review).length > 0)) ? _c('div', {
    staticClass: "card"
  }, [(_vm.user_type == 2 && (_vm.order.order_user_review[0].product_reviewed_by != '')) ? _c('h4', [_vm._v(_vm._s(_vm.order.order_user_review[0].product_reviewed_by) + "'s Review")]) : _vm._e(), _vm._v(" "), (_vm.user_type == 1) ? _c('h4', [_vm._v("Your Review")]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin": "8px"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.order.order_user_review[0].product_review))]), _vm._v(" "), _c('p', {
    staticClass: "rate",
    staticStyle: {
      "line-height": "0.7",
      "margin-top": "-0.2em"
    }
  }, _vm._l((Math.round(_vm.order.order_user_review[0].product_rate)), function(rate) {
    return _c('i', {
      staticClass: "fas fa-star",
      staticStyle: {
        "padding-right": "3px"
      }
    })
  })), _vm._v(" "), (_vm.user_type == 1) ? _c('div', [_c('hr'), _vm._v(" "), _vm._m(15)]) : _vm._e()]) : _c('div', {
    staticClass: "card"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No reviews yet")])]), _vm._v(" "), ((_vm.user_type == 1) && (Object.keys(_vm.order.order_user_review).length == 0)) ? _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin": "1em",
      "margin-bottom": "8em"
    }
  }, [_c('h3', [_vm._v("Give a star rating")]), _vm._v(" "), _c('p', [_vm._v("Your rate would help the provider and other buyers in making purchase decisions")]), _c('br'), _vm._v(" "), _vm._l((5), function(star) {
    return _c('div', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [_c('a', {
      staticClass: "card-link",
      staticStyle: {
        "margin-right": "2em",
        "font-size": "28px",
        "line-height": "0.4",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.setRate(_vm.order.order_items[0], star)
        }
      }
    }, [_c('span', [_c('i', {
      staticClass: "fa fa-star-o",
      attrs: {
        "id": 'rate-' + star
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-star",
      staticStyle: {
        "display": "none",
        "color": "#f7df2b"
      },
      attrs: {
        "id": 'rated-' + star
      }
    })]), _vm._v(" "), _c('p', {
      staticStyle: {
        "margin-top": "0.2em",
        "color": "#000000",
        "font-size": "12px",
        "font-weight": "600"
      }
    }, [(star == 1) ? _c('span', [_vm._v("Bad")]) : _vm._e(), _vm._v(" "), (star == 2) ? _c('span', [_vm._v("Not Bad")]) : _vm._e(), _vm._v(" "), (star == 3) ? _c('span', [_vm._v("Okay")]) : _vm._e(), _vm._v(" "), (star == 4) ? _c('span', [_vm._v("Good")]) : _vm._e(), _vm._v(" "), (star == 5) ? _c('span', [_vm._v("Great")]) : _vm._e()])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.order_items[0].product_item_review),
      expression: "order.order_items[0].product_item_review"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.order.order_items[0].product_item_review)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.order.order_items[0].product_item_review = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('a', {
    staticClass: "card-link x-cta-btn",
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": function($event) {
        _vm.submitReview(0)
      }
    }
  }, [_vm._v("Submit\r\n                      "), (_vm.action_loading) ? _c('span', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })]) : _vm._e()]), _vm._v(" "), _c('a', {
    staticClass: "card-link x-cta-btn",
    staticStyle: {
      "float": "right",
      "background-color": "#eee"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('shareBox')
      }
    }
  }, [_vm._v("\r\n                      Not now, later\r\n                    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])], 2) : _vm._e()])]) : ((_vm.set_in_view == 'setReceiptsView') || (_vm.set_in_view == 'setDeliveryReceiptsView')) ? _c('div', [_c('div', {
    staticClass: "card-box card-02"
  }, [(_vm.set_in_view == 'setDeliveryReceiptsView') ? _c('h4', [_vm._v("Delivery Payment Receipts")]) : _c('h4', [_vm._v("Payment Receipts")]), _vm._v(" "), (_vm.site_user_type == 2) ? _c('div', [(Object.keys(_vm.order_media).length == 0) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#f32144"
    }
  }, [_vm._v("No Upload yet")])]) : _c('div', [(((_vm.user_type == 3) && (_vm.order.order_delivery_business && (_vm.order.order_delivery_business.business == _vm.sellpoint.business_id)))) ? _c('div', [((Object.keys(_vm.order_delivery_business_media).length) == 0) ? _c('p', {
    staticStyle: {
      "color": "#f32144"
    }
  }, [_vm._v("No Upload yet")]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), ((Object.keys(_vm.file_info).length == 0)) ? _c('div', [(_vm.site_user_type == 1) ? _c('div', [_c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer",
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "upload-btn sp-button-02",
    staticStyle: {
      "padding": "5px 8px",
      "line-height": "0.8",
      "font-size": "16px",
      "color": "#000000",
      "background-color": "#f7df2b",
      "border": "#f7df2b solid"
    },
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Upload New Receipt > ")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeNewPhoto($event, 'transfer-receipt')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [(_vm.set_view_image) ? _c('div', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.image_view_url
    }
  })]) : _vm._e(), _vm._v(" "), ((Object.keys(_vm.order_media).length > 0)) ? _c('div', {
    staticClass: "category-slide"
  }, [(_vm.set_in_view == 'setDeliveryReceiptsView') ? _c('ul', _vm._l((_vm.order_media), function(item, index) {
    return ((item.data_image_for_module_category == 37)) ? _c('li', {}, [_c('div', {
      staticStyle: {
        "height": "180px"
      }
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.set_view_image = false;
          _vm.image_view_url = item.data_image;
          _vm.set_view_image = true;
        }
      }
    }, [(item.data_image) ? _c('img', {
      staticStyle: {
        "width": "70px",
        "height": "60px",
        "border-radius": "8px"
      },
      attrs: {
        "src": item.data_image
      }
    }) : _vm._e()])])]) : _vm._e()
  })) : _c('ul', _vm._l((_vm.order_media), function(item, index) {
    return ((item.data_image_for_module_category == 0)) ? _c('li', {}, [_c('div', {
      staticStyle: {
        "height": "180px"
      }
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.set_view_image = false;
          _vm.image_view_url = item.data_image;
          _vm.set_view_image = true;
        }
      }
    }, [(item.data_image) ? _c('img', {
      staticStyle: {
        "width": "70px",
        "height": "60px",
        "border-radius": "8px"
      },
      attrs: {
        "src": item.data_image
      }
    }) : _vm._e()])])]) : _vm._e()
  })), _vm._v(" "), _c('hr')]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.site_user_type == 1) ? _c('div', [_c('div', [_c('div', {
    staticClass: "card"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "prImagePreview"
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [(_vm.set_in_view == 'setDeliveryReceiptsView') ? _c('button', {
    staticClass: "btn btn-default wnf-button",
    staticStyle: {
      "width": "30vw",
      "margin-left": "0vw",
      "padding": "5px 3px"
    },
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.uploadFlexiPaymentReceipt(37, _vm.order, _vm.order.order_no, 'transferred')
      }
    }
  }, [_vm._v("Upload "), (_vm.action_loading) ? _c('span', [_c('i', {
    staticClass: "fa fa-circle-o-notch"
  })]) : _vm._e()]) : _c('button', {
    staticClass: "btn btn-default wnf-button",
    staticStyle: {
      "width": "30vw",
      "margin-left": "0vw",
      "padding": "5px 3px"
    },
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.uploadFlexiPaymentReceipt(0, _vm.order, _vm.order.order_no, 'transferred')
      }
    }
  }, [_vm._v("Upload "), (_vm.action_loading) ? _c('span', [_c('i', {
    staticClass: "fa fa-circle-o-notch"
  })]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default wnf-button",
    staticStyle: {
      "width": "30vw",
      "margin-left": "0vw",
      "padding": "5px 3px",
      "background-color": "#f5f4e6",
      "color": "#000000"
    },
    on: {
      "click": function($event) {
        _vm.resetImageUpload()
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()])])]) : _vm._e()])]) : (_vm.set_in_view == 'setOrderUpdateStatus') ? _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('h4', [_vm._v("Order Update")]), _c('hr'), _vm._v(" "), (_vm.site_user_type == 2) ? _c('div', [(_vm.order.order_status_id == 7) ? _c('div', [_c('p', {
    staticStyle: {
      "font-weight": "lighter",
      "font-size": "small"
    }
  }, [_vm._v("Have you received Payment?")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "background": "#f7df2b",
      "color": "#000000"
    },
    on: {
      "click": function($event) {
        _vm.setOrderCustomConfirmPaymentUpdate(_vm.order)
      }
    }
  }, [_vm._v("\r\n                      Yes, Received "), (_vm.action_loading) ? _c('span', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })]) : _vm._e()])]) : _c('div', [(_vm.order.order_status_id == 2) ? _c('p', [_vm._v("Waiting for order delivery confirmation. Ensure you have settled delivery. ")]) : _c('p', [_vm._v("Waiting for order confirmation. Ensure you have settled order payment and delivery. ")])])]) : _vm._e(), _vm._v(" "), (_vm.site_user_type == 1) ? _c('div', [(_vm.order.order_status_id == 2) ? _c('div', [_c('p', {
    staticStyle: {
      "font-weight": "lighter",
      "font-size": "small"
    }
  }, [_vm._v("Have you received your Order?")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "background": "#f7df2b",
      "color": "#000000"
    },
    on: {
      "click": function($event) {
        _vm.setOrderCustomUpdates(_vm.order, 'received')
      }
    }
  }, [_vm._v("\r\n                      Yes, Received  "), (_vm.action_loading) ? _c('span', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })]) : _vm._e()])]) : _c('div', [(_vm.order.order_status_id == 21) ? _c('p', [_c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Received")]), _c('br'), _c('br'), _vm._v(" "), _vm._m(16)]) : _c('p', [_vm._v("Waiting for order confirmation. Ensure you have settled payment. ")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "setMakePayment"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h4', [_vm._v("Have you made payment?")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    on: {
      "click": function($event) {
        _vm.setOrderCustomUpdates(_vm.order, 'custom_set_track_make_payment', 1)
      }
    }
  }, [_vm._v("YES\r\n                    "), (_vm.action_loading) ? _c('span', [_c('i', {
    staticClass: "fa fa-circle-o-notch"
  })]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 btn-danger",
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('setMakePayment')
      }
    }
  }, [_vm._v("NO")])])])]) : (_vm.set_in_view == 'setDeliveryPartnerDetails') ? _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "text-align": "left",
      "margin-top": "5px",
      "padding-top": "5px",
      "border-top": "#777777 1px dashed"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "cd-card-row"
  }, [_c('p', {
    staticClass: "cd-card-row-left"
  }, [_vm._v("Delivery by:")]), _vm._v(" "), _c('p', {
    staticClass: "cd-card-row-right"
  }, [_vm._v(_vm._s(_vm.order.order_delivery_business.business_name))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cd-card-row"
  }, [_c('p', {
    staticClass: "cd-card-row-left"
  }, [_vm._v("From:")]), _vm._v(" "), _c('p', {
    staticClass: "cd-card-row-right"
  }, [_vm._v("\r\n                        " + _vm._s(_vm.order.order_business_address) + "\r\n                        "), (_vm.order.order_business_location != '') ? _c('span', [_vm._v(", " + _vm._s(_vm.order.order_business_location))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cd-card-row"
  }, [_c('p', {
    staticClass: "cd-card-row-left"
  }, [_vm._v("To:")]), _vm._v(" "), _c('p', {
    staticClass: "cd-card-row-right"
  }, [_vm._v("\r\n                        " + _vm._s(_vm.order.order_user_delivery_address) + "\r\n                        "), (_vm.order.order_delivery_city_id > 0) ? _c('span', [_vm._v(", " + _vm._s(_vm.order.order_delivery_city))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cd-card-row"
  }, [_c('p', {
    staticClass: "cd-card-row-left"
  }, [_vm._v("Delivery Fee:")]), _vm._v(" "), _c('p', {
    staticClass: "cd-card-row-right"
  }, [_c('span', {
    staticClass: "nra-fmt"
  }, [_vm._v("₦‎")]), _vm._v(_vm._s(_vm.formatCurrency_2(_vm.order.order_delivery_fee)))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), (_vm.site_user_type == 1) ? _c('div', {
    staticClass: "cd-card-row"
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('setRateDeliveryPartnerView')
      }
    }
  }, [_vm._m(17), _vm._v(" "), _c('p', {
    staticClass: "cd-card-row-right"
  }, [(((_vm.site_user_type == 2) || (Object.keys(_vm.order.order_user_review).length > 0))) ? _c('span', [_vm._v("View >")]) : _c('span', [_vm._v("Rate >")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "margin": "1em",
      "margin-bottom": "8em"
    },
    attrs: {
      "id": "setRateDeliveryPartnerView"
    }
  }, [(_vm.order.order_user_delivery_review && (Object.keys(_vm.order.order_user_delivery_review).length > 0)) ? _c('div', {
    staticClass: "card"
  }, [_c('hr', {
    staticStyle: {
      "margin": "8px"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.order.order_user_delivery_review[0].product_review))]), _vm._v(" "), _c('p', {
    staticClass: "rate",
    staticStyle: {
      "line-height": "0.7",
      "margin-top": "-0.2em"
    }
  }, _vm._l((Math.round(_vm.order.order_user_delivery_review[0].product_rate)), function(rate) {
    return _c('i', {
      staticClass: "fas fa-star",
      staticStyle: {
        "padding-right": "3px"
      }
    })
  })), _vm._v(" "), (_vm.site_user_type == 2 && (_vm.order.order_user_delivery_review[0].product_reviewed_by != '')) ? _c('p', [_vm._v(_vm._s(_vm.order.order_user_delivery_review[0].product_reviewed_by) + "'s Review")]) : _vm._e(), _vm._v(" "), (_vm.site_user_type == 1) ? _c('div', [_c('p', [_vm._v("Your Review")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(18)]) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "text-align": "right"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('setRateDeliveryPartnerView')
      }
    }
  }, [_vm._v("x close")])])]) : _c('div', {
    staticClass: "card"
  }, [(_vm.site_user_type == 2) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No reviews yet")]) : _vm._e()]), _vm._v(" "), ((_vm.site_user_type == 1) && (Object.keys(_vm.order.order_user_delivery_review).length == 0)) ? _c('div', {
    staticClass: "card"
  }, [_c('span', {
    staticStyle: {
      "float": "left",
      "font-weight": "600"
    }
  }, [_vm._v("Rate: ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, _vm._l((5), function(star) {
    return _c('span', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [_c('a', {
      staticClass: "card-link",
      staticStyle: {
        "margin-right": "2.5em",
        "font-size": "18px",
        "line-height": "0.4",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.setRate(_vm.order.order_items[0], star)
        }
      }
    }, [_c('span', [_c('i', {
      staticClass: "fa fa-star-o",
      attrs: {
        "id": 'rate-' + star
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-star",
      staticStyle: {
        "display": "none",
        "color": "#f7df2b"
      },
      attrs: {
        "id": 'rated-' + star
      }
    })]), _vm._v(" "), _c('p', {
      staticStyle: {
        "margin-top": "0.2em",
        "color": "#000000",
        "font-size": "12px",
        "font-weight": "600"
      }
    }, [(star == 1) ? _c('span', [_vm._v("Bad")]) : _vm._e(), _vm._v(" "), (star == 2) ? _c('span', [_vm._v("Okay")]) : _vm._e(), _vm._v(" "), (star == 3) ? _c('span', [_vm._v("Good")]) : _vm._e(), _vm._v(" "), (star == 4) ? _c('span', [_vm._v("Great")]) : _vm._e(), _vm._v(" "), (star == 5) ? _c('span', [_vm._v("Superb")]) : _vm._e()])])])
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("How was it, tell us more:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.order_items[0].product_item_review),
      expression: "order.order_items[0].product_item_review"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.order.order_items[0].product_item_review)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.order.order_items[0].product_item_review = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('a', {
    staticClass: "card-link x-cta-btn",
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": function($event) {
        _vm.submitReview(3)
      }
    }
  }, [_vm._v("Submit\r\n                              "), (_vm.action_loading) ? _c('span', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })]) : _vm._e()]), _vm._v(" "), _c('a', {
    staticClass: "card-link x-cta-btn",
    staticStyle: {
      "float": "right",
      "background-color": "#eee"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('shareBox')
      }
    }
  }, [_vm._v("\r\n                              Not now, later\r\n                            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.site_user_type == 1) ? _c('div', {
    staticClass: "cd-card-row"
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.set_in_view = 'setDeliveryReceiptsView'
      }
    }
  }, [_vm._m(19), _vm._v(" "), _c('p', {
    staticClass: "cd-card-row-right"
  }, [(((_vm.site_user_type == 2) || (Object.keys(_vm.order_media).length > 0))) ? _c('span', [_vm._v("View >")]) : _c('span', [_vm._v("Upload >")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]) : _vm._e()])])])]) : (_vm.set_in_view == 'setPromptUpdateOrders') ? _c('div', [_c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-bottom": "8em"
    }
  }, [((Object.keys(_vm.orders_prompt).length > 0)) ? _c('div', [_c('h3', [_vm._v("These Orders below need your feedback,")]), _vm._v(" "), ((_vm.user_type == 1)) ? _c('p', [_vm._v("Go through, to confirm orders that have been delivered to you")]) : _vm._e(), _vm._v(" "), ((_vm.user_type == 2)) ? _c('p', [_vm._v("Go through, to confirm paid and delivered orders")]) : _vm._e(), _vm._v(" "), ((_vm.user_type == 3)) ? _c('p', [_vm._v("Go through, to confirm orders that you have delivered")]) : _vm._e(), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-weight": "800"
    }
  }, [_vm._v("Total (" + _vm._s(Object.keys(_vm.orders_prompt).length) + ")")]), _vm._v(" "), _c('div', [_c('div', _vm._l((_vm.orders_prompt), function(order, opr_dex) {
    return _c('div', {
      staticClass: "card-box card-02",
      staticStyle: {
        "padding": "0.8em 1em",
        "padding-bottom": "1em",
        "border-bottom": "#eee solid",
        "margin-bottom": "0.02em"
      }
    }, [_c('div', [_c('div', {
      staticClass: "col-xs-4 mp0"
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('popBox');
          _vm.setOrderData(order);
        }
      }
    }, [_c('div', {
      staticStyle: {
        "display": "inline",
        "padding-bottom": "1em"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "80px",
        "height": "75px",
        "border-radius": "8px"
      },
      attrs: {
        "src": _vm.img_product_url + order.order_items[0].product_item_group_image
      }
    }), _c('br'), _c('br')])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-8 mp0"
    }, [(_vm.user_type == 3) ? _c('h4', {
      staticStyle: {
        "font-weight": "800",
        "font-size": "16px"
      }
    }, [_vm._v("\r\n                              Delivery to " + _vm._s(order.order_delivery_city) + "\r\n                              "), (order.order_business_location && (order.order_business_location != '')) ? _c('span', [_vm._v("\r\n                                From " + _vm._s(order.order_business_location) + "\r\n                              ")]) : _vm._e()]) : _c('h4', {
      staticStyle: {
        "font-weight": "800"
      }
    }, [_vm._v(_vm._s(order.order_items[0].product_name) + "\r\n                              "), (Object.keys(order.order_items).length > 1) ? _c('span', [_vm._v(" x " + _vm._s(Object.keys(order.order_items).length) + " more items")]) : _vm._e()]), _vm._v(" "), _c('p', [_c('span', {
      staticClass: "nra-fmt"
    }, [_vm._v("₦‎")]), _vm._v(_vm._s(_vm.formatCurrency_2(order.order_total)))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "margin-top": "0em",
        "color": "#777777"
      }
    }, [_vm._v(_vm._s(order.order_time_ago))]), _vm._v(" "), _c('p', [_c('span', {
      staticStyle: {
        "font-weight": "800"
      }
    }, [_vm._v("Status: ")]), _c('span', {
      staticStyle: {
        "color": "#f32144"
      }
    }, [_vm._v(_vm._s(order.order_status))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "border-top": "#f32144 dashed 0px",
        "border-bottom": "#f32144 dashed 0px",
        "padding-top": "4px"
      }
    }, [(_vm.user_type == 1) ? _c('div', [((order.order_status_id == 2) || (order.order_status_id == 18)) ? _c('p', [_vm._v("Have you "), _c('b', [_vm._v("received")]), _vm._v(", this Order? "), _c('button', {
      staticClass: "btn sp-button-02 sp-button-02-sm",
      on: {
        "click": function($event) {
          order.active = opr_dex;
          _vm.setOrderCustomUpdates(order, 'received');
          order.order_status = 'Order Received';
          order.order_status_id = 21;
          _vm.getOrderSets();
        }
      }
    }, [_vm._v("\r\n                                  Yes "), (_vm.action_loading && (order.active == opr_dex)) ? _c('span', [_c('i', {
      staticClass: "fa fa-circle-o-notch fa-spin"
    })]) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), ((_vm.user_type == 2)) ? _c('div', [(order.order_status_id == 7) ? _c('p', [_vm._v("Have you "), _c('b', [_vm._v("received payment")]), _vm._v(" for this Order? "), _c('button', {
      staticClass: "btn sp-button-02 sp-button-02-sm",
      on: {
        "click": function($event) {
          order.active = opr_dex;
          _vm.setOrderCustomConfirmPaymentUpdate(order);
          order.order_status = 'Paid';
          order.order_status_id = 2;
          _vm.getOrderSets();
        }
      }
    }, [_vm._v("\r\n                                  Yes "), (_vm.action_loading && (order.active == opr_dex)) ? _c('span', [_c('i', {
      staticClass: "fa fa-circle-o-notch fa-spin"
    })]) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), ((_vm.user_type == 2) || (_vm.user_type == 3)) ? _c('div', [(order.order_status_id == 2 && (order.order_delivery_business.business_delivery_id == _vm.sellpoint.business_id)) ? _c('p', [_vm._v("Have you "), _c('b', [_vm._v("delivered")]), _vm._v(" this Order? "), _c('button', {
      staticClass: "btn sp-button-02 sp-button-02-sm",
      on: {
        "click": function($event) {
          order.active = opr_dex;
          _vm.setOrderCustomUpdates(order, 'delivered');
          order.order_status = 'Delivered';
          order.order_status_id = 18;
          _vm.getOrderSets();
        }
      }
    }, [_vm._v("\r\n                                  Yes "), (_vm.action_loading && (order.active == opr_dex)) ? _c('span', [_c('i', {
      staticClass: "fa fa-circle-o-notch fa-spin"
    })]) : _vm._e()])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])
  }))])]) : _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "5em"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No Orders yet")])])])]) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/dashboard"
    }
  }, [_c('i', {
    staticClass: "fas fa-user"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/manage/orders"
    }
  }, [_c('div', {
    staticClass: "card-menu-btn",
    staticStyle: {
      "margin": "1em 0"
    }
  }, [_c('h5', [_vm._v("Manage Store Orders")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Qty")]), _vm._v(" "), _c('th', [_vm._v("Item")]), _vm._v(" "), _c('th', [_vm._v("Cost")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Qty")]), _vm._v(" "), _c('th', [_vm._v("Item")]), _vm._v(" "), _c('th', [_vm._v("Cost")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-menu-col card-menu-col-active"
  }, [_c('h5', [_vm._v("All")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-menu-col"
  }, [_c('h5', [_vm._v("Today")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-menu-col"
  }, [_c('h5', [_vm._v("Not Paid")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-menu-col"
  }, [_c('h5', [_vm._v("Delivered")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-menu-col"
  }, [_c('h5', [_vm._v("This Week")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-menu-col"
  }, [_c('h5', [_vm._v("This Month")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-2 mp0"
  }, [_c('b', [_vm._v("From: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("S/N")]), _vm._v(" "), _c('th', [_vm._v("Order No")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Items")]), _vm._v(" "), _c('th', [_vm._v("From")]), _vm._v(" "), _c('th', [_vm._v("Destination")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Time")]), _vm._v(" "), _c('th', [_vm._v("-")]), _vm._v(" "), _c('th', [_vm._v("-")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "left",
      "padding": "1em",
      "padding-left": "0",
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-left"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "-1em",
      "margin-bottom": "-0.3em",
      "padding": "0",
      "font-size": "2em"
    }
  }, [_c('span', [_vm._v("___")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "color": "#777777"
    }
  }, [_c('i', [_vm._v("__Thank you for your feedback__")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "color": "#777777"
    }
  }, [_c('i', [_vm._v("__Thank you for your patronage__")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cd-card-row-left"
  }, [_c('i', {
    staticClass: "fas fa-star",
    staticStyle: {
      "color": "#f7df2b"
    }
  }), _vm._v(" Rate Delivery\r\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "color": "#777777"
    }
  }, [_c('i', [_vm._v("__Thank you for your feedback__")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cd-card-row-left"
  }, [_c('i', {
    staticClass: "fas fa-upload",
    staticStyle: {
      "color": "#09c046"
    }
  }), _vm._v(" Delivery Receipts\r\n                        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17275c14"}!./src/pages/Components/OrdersManagement/template.html
// module id = 536
// module chunks = 0